import { inject, Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router'
import { AuthenticationService } from './authentication.service'

@Injectable({
   providedIn: 'root',
})
export class PublicPageServiceGuard {
   private _router = inject(Router)
   private _authService = inject(AuthenticationService)

   canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
      if (this._authService.keycloakAngular.isLoggedIn()) {
         this._router.navigate(['/'])
         return false
      }
      return true
   }
}

export const PublicPageGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean => {
   return inject(PublicPageServiceGuard).canActivate(next, state)
}
